/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'
import { AccordionProps } from '@material-ui/core'
import Introduction from 'components/Introduction'
import { observer } from 'mobx-react'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { useText } from 'stores/utils/hooks/useText'
import {
  AmplitudeEvent,
  InformationElement
} from '../../utils/tracking/amplitude/amplitude.interface'

type Props = {
  path: string
  children: AccordionProps['children']
  opened?: boolean
}

const PathIntroduction = observer(
  ({ path, children, opened = false }: Props) => {
    const onChange = useCallback(
      (isVisible: boolean) => {
        trackInAmplitude(AmplitudeEvent.ToggleInformation, {
          path,
          type: InformationElement.IntroText,
          isVisible
        })
      },
      [path]
    )

    const {
      text: { copy }
    } = useText()

    const props = {
      onChange,
      id: path,
      title: copy?.introduction?.headline,
      expanded: opened,
      children
    }

    return <Introduction {...props} />
  }
)

export default PathIntroduction
